import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import {
  SignOutIcon,
  ShieldLockIcon,
  PersonIcon,
} from "@primer/octicons-react";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import { BASENAME } from "./../../services/constants";
import AuthService from "../../services/auth.service.ts";
import ProfileImage from "../../components/profile-image.component";

import logo from "./img/campboard_icon.png";

export default function Header({
  onChangeDarkmode,
  isDarkmodeActive,
  isSessionActive,
  isAdminSessionActive,
  onSignOut,
}) {
  const history = useHistory();
  const [dropdownButtonHovered, setDropdownButtonHovered] = useState(false);

  const signOutAndRedirect = () => {
    AuthService.logout();
    setDropdownButtonHovered(false);
    history.push("/");

    if (typeof onSignOut === "function") {
      onSignOut();
    }
  };

  const toggleDarkMode = (checked) => {
    if (typeof onChangeDarkmode === "function") {
      onChangeDarkmode(checked);
    }
  };

  const localUser = AuthService.getLocalUser();

  return (
    <div>
      <Navbar bg="custom" variant="dark" collapseOnSelect expand="lg">
        <Navbar.Brand
          onClick={() => history.push(BASENAME)}
          style={{ cursor: "pointer" }}
        >
          <img
            alt=""
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top ml-3 mr-3"
          />{" "}
          Campboard
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Collapse>
          {isSessionActive && (
            <Nav className="mr-auto">
              <Nav.Link
                onClick={() => history.push(`${BASENAME}account/dashboard`)}
              >
                Dashboard
              </Nav.Link>
              {isAdminSessionActive === true && (
                <>
                  <Nav.Link
                    onClick={() =>
                      history.push(
                        `${BASENAME}admin-dashboard/overview?panel=overview`,
                      )
                    }
                  >
                    <ShieldLockIcon className="mr-2" /> Übersicht (Admin)
                  </Nav.Link>
                  <Nav.Link
                    onClick={() =>
                      history.push(
                        `${BASENAME}admin-dashboard/overview?panel=manage_users`,
                      )
                    }
                  >
                    <ShieldLockIcon className="mr-2" /> Benutzer verwalten
                    (Admin)
                  </Nav.Link>
                  <Nav.Link
                    onClick={() =>
                      history.push(
                        `${BASENAME}admin-dashboard/overview?panel=manage_topics`,
                      )
                    }
                  >
                    <ShieldLockIcon className="mr-2" /> Themen verwalten (Admin)
                  </Nav.Link>
                </>
              )}
            </Nav>
          )}
        </Navbar.Collapse>

        <Navbar.Collapse className="justify-content-end dropdown-menu-right">
          <DarkModeSwitch
            checked={isDarkmodeActive}
            onChange={toggleDarkMode}
            style={{ marginRight: "1.5rem", userSelect: "none" }}
            sunColor={"white"}
          />
          {isSessionActive && (
            <ul className="navbar-nav" tabIndex="0">
              <li className="nav-item dropdown" aria-label="Profile dropdown">
                {/* HIER sitzt das Profilbild als klickbarer Menü-Trigger */}
                <div
                  className="nav-link d-flex align-items-center"
                  role="button"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setDropdownButtonHovered(!dropdownButtonHovered)
                  }
                >
                  <ProfileImage
                    width="40"
                    height="40"
                    className="rounded-circle"
                    alt="Menüschaltfläche, derzeitiges Profil"
                  />
                  <span className="ml-2 text-white font-weight-bold d-none d-md-inline">
                    {localUser?.firstname}
                  </span>
                </div>

                <div
                  className="dropdown-menu dropdown-menu-right"
                  style={{ display: dropdownButtonHovered ? "block" : "none" }}
                >
                  <NavDropdown.Header>
                    Hallo, <b>{localUser?.firstname}</b> 🎉!
                  </NavDropdown.Header>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={() => history.push(`${BASENAME}account/manage/`)}
                  >
                    <PersonIcon size={16} /> &nbsp;&nbsp;Profil
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={signOutAndRedirect}>
                    <SignOutIcon size={16} /> &nbsp;&nbsp;Abmelden
                  </NavDropdown.Item>
                </div>
              </li>
            </ul>
          )}
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}
